import { useEffect, useState } from 'react';
import { fetchSSEToken } from 'shared/api/services/sse';

export const useSSE = <T>(
  endpoint: string,
  onMessage: (data: T) => void,
  params?: string,
  isTailMode: boolean = false
) => {
  // const { data, isLoading, error, refetch } = useQuery({
  //   queryKey: ['sse', type],
  //   queryFn: () => fetchSSEToken(),
  //   enabled: false,
  // });

  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    let eventStream: EventSource | null = null;
    if (isTailMode) {
      const handleSse = async () => {
        const data = await fetchSSEToken();
        if (!data) return;

        eventStream = new EventSource(
          `${process.env.NOTIFICATIONS_API}/${endpoint}?session=${data?.sessionId}${params || ''}`
        );

        // Connection opened

        setIsConnected(true);

        // Message received and JSON parsed
        eventStream.onmessage = (event) => {
          const parsedData = JSON.parse(event.data);
          onMessage(parsedData);
        };

        // Error handling
        eventStream.onerror = () => {
          setIsConnected(false);
          // console.debug('Error connecting to SSE:', error);
          eventStream?.close();
        };
      };

      handleSse();
    }
    // Cleanup on unmount
    return () => {
      if (eventStream) {
        eventStream.close();
        setIsConnected(false);
        // console.debug('EventSource closed ', endpoint);
      }
    };
  }, [endpoint, onMessage, isTailMode]);

  return { isConnected };
};
